var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.658,
    height: 125.966,
    viewBox: "0 0 97.658 125.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-download-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 97.658,
    height: 125.966,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-1211.671 -430.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(1211.671 430.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#home-download-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M143.007,17.391a5.661,5.661,0,0,1-5.649-5.649V0H68.014a2.118,2.118,0,0,0-2.108,2.108V115.487a2.118,2.118,0,0,0,2.108,2.108h84.626a2.119,2.119,0,0,0,2.108-2.108v-98.1Zm-8.956,33.572a1.767,1.767,0,0,1,.954-3.4l7.3,2.058a1.761,1.761,0,0,1,1.094.894l.006.012.01.02.009.018h0l.015.032.012.028,0,0,.011.027,0,.008c.008.021.016.041.024.062l.011.033.006.017.007.023,0,.011.009.03,0,.01.007.027,0,.014a1.752,1.752,0,0,1,.053.43h0v7.31a1.771,1.771,0,0,1-3.541,0V54.664L128.695,62.41a1.757,1.757,0,0,1-1,.308v0H103.987L95.368,68.6a1.759,1.759,0,0,1-1,.307v0H78.608a1.771,1.771,0,1,1,0-3.541H93.833l8.523-5.81a1.764,1.764,0,0,1,1.091-.376H127.16L137.7,51.992ZM82.688,17.089a20.171,20.171,0,0,1,12.8-5.871l.062,0q.719-.051,1.451-.052A20.236,20.236,0,0,1,117.233,31.4q0,.289-.008.575c0,.02,0,.039,0,.059A20.235,20.235,0,1,1,82.688,17.089m60.4,92.168H77.563a1.771,1.771,0,1,1,0-3.541H83.7V79.968A1.771,1.771,0,0,1,85.469,78.2H97.243a1.771,1.771,0,0,1,1.771,1.771v25.748h4.2V74.875a1.771,1.771,0,0,1,1.771-1.771h11.774a1.771,1.771,0,0,1,1.771,1.771v30.841h4.2V71.047a1.771,1.771,0,0,1,1.771-1.771h11.774a1.771,1.771,0,0,1,1.771,1.771v34.669h5.038a1.771,1.771,0,1,1,0,3.541",
    transform: "translate(-57.089 -0.001)",
    fill: "#e761a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 8.233,
    height: 32.898,
    transform: "translate(69.189 72.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 8.233,
    height: 29.07,
    transform: "translate(49.67 76.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 8.233,
    height: 23.978,
    transform: "translate(30.151 81.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M627.1,29.44a2.1,2.1,0,0,1-.621-1.487V18.716l11.345,11.345h-9.237a2.1,2.1,0,0,1-1.487-.621",
    transform: "translate(-542.671 -16.212)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M10.925,175.342H88.842v2.723a2.12,2.12,0,0,1-2.108,2.108H2.108A2.119,2.119,0,0,1,0,178.065V64.687a2.119,2.119,0,0,1,2.108-2.108H5.276V169.693a5.661,5.661,0,0,0,5.649,5.649",
    transform: "translate(0 -54.207)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M317.611,125.4h-16.24V109.938a16.694,16.694,0,0,1,16.24,15.463",
    transform: "translate(-261.054 -95.231)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M178.411,140.3a16.7,16.7,0,0,1,8.673-28.206v16.945a1.771,1.771,0,0,0,1.771,1.771h17.9a16.7,16.7,0,0,1-28.34,9.49",
    transform: "translate(-150.308 -97.097)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c2f7f7475edc87fb82e1d0418577dc85.svg";
export { ForwardRef as ReactComponent };